import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import index from './components/index.vue'
import Show from './components/show.vue'
import ShowV2 from './components/v2/show.vue'
import ShowDetail from './components/show-detail.vue'
import Discovery from './components/v2/discovery.vue'
import SearchPage from './components/v2/search-page.vue'
import TopicDetail from './components/blocks/topic/detail.vue'
import TopicsAll from './components/topics-all'
import Purchased from './components/v2/purchased.vue'
import PersonalBase from './components/v2/personal/personal-base.vue'
import PersonalIndex from './components/v2/personal/index.vue'
import PersonalHistory from './components/v2/personal/history.vue'
import PersonalPurchase from './components/v2/personal/purchase.vue'
import PersonalGiftCardsMine from './components/v2/personal/giftcards-mine.vue'
import PersonalGiftCardsToMe from './components/v2/personal/giftcards-to-me.vue'
import PersonalVouchers from './components/v2/personal/vouchers.vue'
import PersonalRedeemed from './components/v2/personal/redeemed.vue'
import PersonalMyComments from './components/v2/personal/my-comments.vue'
import PersonalILikedComments from './components/v2/personal/i-liked-comments.vue'
import PersonalReplyToMeComments from './components/v2/personal/reply-to-me-comments.vue'
import EpisodeDetail from './components/episode-detail.vue'
import AuthWechat from './components/auth-wechat.vue'
import PayWechat from './components/pay-wechat.vue'
import Comments from './components/comments.vue'
import PublicEpisodes from './components/public-episodes'
import PremiumEpisodes from './components/premium-episodes'
import EpisodesAll from './components/episodes-all'
import SaleEpisodes from './components/sale-episodes'
import CategoryDetail from './components/category-detail'
import HotCommentsList from './components/hot-comments-list'
import UserCenterBase from './components/user-center/base.vue'
import UserCenterIndex from './components/user-center/index.vue'
import UserCenterHistory from './components/user-center/history.vue'
import UserCenterPurchase from './components/user-center/purchase.vue'
import UserCenterGiftCardsMine from './components/user-center/giftcards-mine.vue'
import UserCenterGiftCardsToMe from './components/user-center/giftcards-to-me.vue'
import UserCenterMyComments from './components/user-center/my-comments.vue'
import UserCenterILikedComments from './components/user-center/i-liked-comments.vue'
import UserCenterReplyToMeComments from './components/user-center/reply-to-me-comments.vue'
import BoughtEpisodeList from './components/bought-episode-list.vue'
import GiftCardDetailPage from './components/gift-card-detail-page.vue'
import InvitationDetail from './components/invitation-detail.vue'
import store from './store/index'

Vue.use(VueRouter)

const routes = [
  {path: '/', component: App},
  {path: '/index', component: index},
  {path: '/auth/wechat/', component: AuthWechat},
  {
    path: '/show/:slug', component: Show,
    children: [
      {
        path: '',
        name: 'ShowDetail',
        component: ShowDetail,
        meta: {
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'public/',
        name: 'PublicEpisodes',
        component: PublicEpisodes
      },
      {
        path: 'premium/',
        name: 'PremiumEpisodes',
        component: PremiumEpisodes
      },
      {
        path: 'hot-comments/',
        name: 'HotCommentsList',
        component: HotCommentsList
      },
      {
        path: 'sale/',
        name: 'SaleEpisodes',
        component: SaleEpisodes
      },
      {
        path: 'user-center', component: UserCenterBase,
        children: [
          {
            path: '',
            name: 'UserCenterIndex',
            component: UserCenterIndex
          },
          {
            path: 'history/',
            name: 'UserCenterHistory',
            component: UserCenterHistory
          },
          {
            path: 'purchase/',
            name: 'UserCenterPurchase',
            component: UserCenterPurchase
          },
          {
            path: 'giftcards-mine/',
            name: 'UserCenterGiftCardsMine',
            component: UserCenterGiftCardsMine
          },
          {
            path: 'giftcards-to-me/',
            name: 'UserCenterGiftCardsToMe',
            component: UserCenterGiftCardsToMe
          },

          {
            path: 'my-comments/',
            name: 'UserCenterMyComments',
            component: UserCenterMyComments
          },
          {
            path: 'i-liked-comments/',
            name: 'UserCenterILikedComments',
            component: UserCenterILikedComments
          },
          {
            path: 'reply-to-me-comments/',
            name: 'UserCenterReplyToMeComments',
            component: UserCenterReplyToMeComments
          }
        ]
      }
    ]
  },
  {
    path: '/show/:slug/v2', component: ShowV2,
    children: [
      {
        path: '',
        name: 'Discovery',
        component: Discovery,
        // meta: {
        //   keepAlive: true // 需要被缓存
        // }
      },
      {
        path: 'search',
        name: 'SearchPage',
        component: SearchPage,
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'purchased',
        name: 'Purchased',
        component: Purchased,
        meta: {
          keepAlive: true // 需要被缓存
        }
      },
      // {
      //   path: 'personal',
      //   name: 'Personal',
      //   component: Personal,
      //   meta: {
      //     keepAlive: true // 需要被缓存
      //   }
      // },
      {
        path: 'episodes-all/',
        name: 'EpisodesAll',
        component: EpisodesAll
      },
      {
        path: 'topics-all/',
        name: 'TopicsAll',
        component: TopicsAll
      },
      {
        path: 'personal', component: PersonalBase,
        children: [
          {
            path: '',
            name: 'PersonalIndex',
            component: PersonalIndex
          },
          {
            path: 'history/',
            name: 'PersonalHistory',
            component: PersonalHistory
          },
          {
            path: 'purchase/',
            name: 'PersonalPurchase',
            component: PersonalPurchase
          },
          {
            path: 'giftcards-mine/',
            name: 'PersonalGiftCardsMine',
            component: PersonalGiftCardsMine
          },
          {
            path: 'giftcards-to-me/',
            name: 'PersonalGiftCardsToMe',
            component: PersonalGiftCardsToMe
          },
          {
            path: 'vouchers/',
            name: 'PersonalVouchers',
            component: PersonalVouchers
          },
          {
            path: 'redeemed/',
            name: 'PersonalRedeemed',
            component: PersonalRedeemed
          },
          {
            path: 'my-comments/',
            name: 'PersonalMyComments',
            component: PersonalMyComments
          },
          {
            path: 'i-liked-comments/',
            name: 'PersonalILikedComments',
            component: PersonalILikedComments
          },
          {
            path: 'reply-to-me-comments/',
            name: 'PersonalReplyToMeComments',
            component: PersonalReplyToMeComments
          }
        ]
      }
    ]
  },
  {
    path: '/episode/:episodeId/',
    name: 'EpisodeDetail',
    component: EpisodeDetail,
    beforeEnter: (to, from, next) => {
      window.console.log("路由守卫")
      window.console.log(to)
      window.console.log(from)
      // window.console.log(next)
      if (from.name != undefined || from.name != null) {
        let fullPath = from.fullPath
        store.commit('setPrevFullPath', fullPath)
      }
      next()
    }
  },
  {
    path: '/giftcard/:giftcardId/',
    name: 'GiftCardDetailPage',
    component: GiftCardDetailPage,
    beforeEnter: (to, from, next) => {
      window.console.log("路由守卫")
      window.console.log(to)
      window.console.log(from)
      // window.console.log(next)
      if (from.name != undefined || from.name != null) {
        let fullPath = from.fullPath
        store.commit('setPrevFullPath', fullPath)
      }
      next()
    }
  },
  {
    path: '/invitation/:invitationId/',
    name: 'InvitationDetail',
    component: InvitationDetail
  },
  {
    path: '/category/:categoryId/',
    name: 'CategoryDetail',
    component: CategoryDetail,
    beforeEnter: (to, from, next) => {
      window.console.log("路由守卫")
      window.console.log(to)
      window.console.log(from)
      // window.console.log(next)
      if (!store.state.fullPathToCategory) {
        if (from.name != undefined || from.name != null) {
          let fullPath = from.fullPath
          store.commit('setFullPathToCategory', fullPath)
        }
      }
      next()
    }
  },
  {
    path: '/topic/:topicId/',
    name: 'TopicDetail',
    component: TopicDetail,
    beforeEnter: (to, from, next) => {
      window.console.log("路由守卫")
      window.console.log(to)
      window.console.log(from)
      // window.console.log(next)
      if (!store.state.fullPathToTopic) {
        if (from.name != undefined || from.name != null) {
          let fullPath = from.fullPath
          store.commit('setFullPathToTopic', fullPath)
        }
      }
      next()
    }
  },
  {
    path: '/comments/:applabel/:classname/:objectid/',
    name: 'Comments',
    component: Comments
  },
  {
    path: '/pay/wechat/',
    name: 'PayWechat',
    component: PayWechat
  },
  // {
  //   path: '/show/:slug/user-center/',
  //   name: 'UserCenter',
  //   component: UserCenter
  // },
  {
    path: '/show/:slug/bought-episodes/',
    name: 'BoughtEpisodeList',
    component: BoughtEpisodeList
  }
]
const router = new VueRouter({
  routes
  // scrollBehavior (to, from, savedPosition) {
  //   window.console.log("切换页面")
  //   window.console.log(to)
  //   window.console.log(from)
  //   window.console.log(savedPosition)
  //   window.scroll(0, 0)
  // }
})

router.beforeEach((to, from, next) => {
  // window.scroll(0, 0)
  next()
})

export default router
